import { h } from "omi";

import { IconProps } from "@/components";

export function TwitterIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" width={width} height={height}>
      <g clip-path="url(#a)">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="m16.5453 23.5-5.5494-7.9099L4.04872 23.5h-2.9391l8.58232-9.7689L1.10962 1.5h7.54595l5.23023 7.45502L20.4391 1.5h2.9391l-8.184 9.3165L24.0913 23.5h-7.546Zm3.273-2.23h-1.9787L5.31797 3.73h1.97899l5.01504 7.0232.8672 1.2187 6.6391 9.2981Z"
          clip-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" transform="translate(.599854 .5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
